import { GET_MENU_SUCCESS, GET_MENU_FAILURE } from '../constants/actionTypes';

const INITIAL_STATE = {
  data: [],
};

export default function menus(state = INITIAL_STATE, action) {
  switch (action.type) {
    case GET_MENU_SUCCESS:
      return { ...state, data: action.payload.data };
    case GET_MENU_FAILURE:
      return { ...state, data: [] };
    default:
      return state;
  }
}
